(ns basic-components.collapsible-panel
  (:require [reagent.core :as r]))

(defn view [{:keys [state panel-key start-open?] :as args} _ _]
  (let [panel-key (or panel-key :panel)
        state (or state
                  (r/atom {}))
        val (get @state panel-key)
        already-setup? (contains? val :open?)]
    (when (and (not already-setup?)
               (contains? args :start-open?))
      (swap! state assoc-in [panel-key :open?] start-open?))
    (fn [{:keys [panel-key force-closed? force-open?]} header content]
      (let [open? (cond force-closed?
                        false
                        force-open?
                        true
                        :else
                        (get-in @state [panel-key :open?]))]
        [:div
         [:div
          [:span
           {:class    "pb-3 inline-flex items-center font-bold gap-3"
            :on-click (fn [_]
                        (swap! state update-in [panel-key :open?] not))}
           header
           ; Not sure we need collapse here
            (if open?
              [:i.far.fa-chevron-down]
              [:i.far.fa-chevron-right])
           ]]
         [:div.collapsible-panel-content
          {:style {:transition "max-height 0.2s"
                   ;; content-height doesn't always update properly using :ref when contents change.
                   ;; No transition until fixed:
                   :max-height (when-not open? 0)
                   #_(if open?
                       content-height
                       0)}}
          [:div
           content]]]))))
